const CREATE_ACCOUNT_LABELS = {
  global: {
    addEditAddress: {
      lbl_addEditAddress_postalCode: 'Postal Code',
    },
  },
};

export default CREATE_ACCOUNT_LABELS;
